var map = {
	"./Machbarkeitsantrag.png": "78da",
	"./archiving.png": "6589",
	"./begutachtung.png": "abf6",
	"./datausagecontract.png": "7c10",
	"./dip_landing.png": "0ac2",
	"./dmp.png": "23a7",
	"./feasibility_abfrage.png": "5bd2",
	"./projektantrag.png": "4ea6",
	"./research.png": "2805",
	"./rueckuebermittlung.png": "4e8a",
	"./uac-req.png": "1add"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "685b";